import React from 'react';
import { cn } from '../../lib/cn';

export interface BrandLogoProps {
  src: string;
  alt?: string;
  className?: string;
}

export function BrandLogo({ src, alt = 'Elva', className }: BrandLogoProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={cn('h-[26px] w-[26px] shrink-0 object-contain', className)}
    />
  );
}
